export const DOM_READY = 'DOMContentLoaded';

export const domReadyPromise: Promise<boolean> = new Promise<boolean>((resolve) => {
  if (document.readyState === 'loading') {
    const onReady = (): void => {
      document.removeEventListener(DOM_READY, onReady);
      resolve(true);
    };
    document.addEventListener(DOM_READY, onReady);
  } else {
    setTimeout(() => resolve(true));
  }
});

export default domReadyPromise;
